import $ from "jquery";

// Global variables
if (!document.location.origin) {
    //doesn't exist on older versions of internet explorer 11
    document.location.origin =
        document.location.protocol +
        "//" +
        document.location.hostname +
        (document.location.port ? ":" + document.location.port : "");
}

let url = "";
let urlWebsite = "";
if (document.location.origin.indexOf("localhost") > -1) {
    url = "https://backend.dev.viennaoffices.at";
    urlWebsite = "https://dev.viennaoffices.at";
} else if (document.location.origin.indexOf("test") > -1) {
    url = document.location.origin;
    urlWebsite = "http://test.viennaoffices.at";
} else if (document.location.origin.indexOf("dev") > -1) {
    url = document.location.origin.replace(/^https?:\/\/cms\./, 'https://backend.'); // set url to subdomain of admin system. e.g. https://cms.dev.viennaoffices.at becomes https://backend.dev.viennaoffices.at
    urlWebsite = "https://dev.viennaoffices.at";
} else {
    url = "https://backend.viennaoffices.at";
    urlWebsite = "https://www.viennaoffices.at";
}

/*const url =
    document.location.origin.indexOf("localhost") > -1
        ? "https://test.viennaoffices.at"
        : document.location.origin.replace(/^https?:\/\/cms\./, 'https://'); // get rid of cms subdomain. https://cms.viennaoffices.at becomes https://viennaoffices.at*/
const pathAdmin = "/";

window.variables = {
    errorMsg: "Leider ist ein Fehler aufgetreten.",
    pathAdmin: pathAdmin,
    url: url,
    ckeditorFolder:
        process.env.NODE_ENV === "production"
            ? document.location.origin + pathAdmin + "/ckeditor"
            : document.location.origin + "/ckeditor",
    version: "1.0x",
    urlWebsite: urlWebsite
};

// Global functions
//type: success, info, warning, danger
window.showAlert = function(type, content) {
    let typeMsg = "";

    switch (type) {
        case "success":
            typeMsg = "Erfolg";
            break;
        case "info":
            typeMsg = "Info";
            break;
        case "warning":
            typeMsg = "Achtung";
            break;
        case "danger":
            typeMsg = "Fehler";
            break;
        default:
            typeMsg = "Info";
            type = "info";
    }

    $("body").append(
        '<div class="alert alert-' +
            type +
            ' alert-top-animated" id="cms-alert" role="alert"><div style="text-align:center"><strong>' +
            typeMsg +
            "! </strong>" +
            content +
            "</div></div>"
    );
    setTimeout(function() {
        $("#cms-alert").remove();
    }, 4444);
};

window.handleErrorResponse = function(error) {
    console.log(error);
    if (error.response && error.response.data.msg)
        window.showAlert("danger", error.response.data.msg);
    else window.showAlert("danger", window.variables.errorMsg);
};
